import SuccessOrFailure from './successOrFailure';

export default SuccessOrFailure;
